// extracted by mini-css-extract-plugin
export default {"notification":"PreferenceCenter_notification__ZB3GR","slideUp":"PreferenceCenter_slideUp__SRt4S","success":"PreferenceCenter_success__9yuO4","error":"PreferenceCenter_error__8vaE7"};